// cartdrawer functions start========
function drawerOpen() {
  $('.cart-drawer').addClass('open_cartdrawer');
  $('body').addClass('js-drawer-open');
  
  $('body').css({overflow: 'hidden'});
  $('html').css({overflow: 'hidden'});

  $('body').css({height: '100%'});
  $('html').css({height: '100%'});

  $('.cart-overlay').show();
}

//$(function ($) {
function drawerClose() {
  $('.cart-drawer').removeClass('open_cartdrawer');
  $('body').removeClass('js-drawer-open');
  
  $('body').css({overflow: 'visible'});
  $('html').css({overflow: 'visible'});

  $('body').css({height: 'auto'});
  $('html').css({height: 'auto'});

  $('.cart-overlay').hide();
}

$(document).on("click", ".site-header__cart", function (e) {
// $('.utils__item.header-cart').click(function(e){
  e.preventDefault();
  $('.cart-drawer').addClass('open_cartdrawer');
  $('body').addClass('js-drawer-open');

  $('body').css({overflow: 'hidden'});
  $('html').css({overflow: 'hidden'});

  $('body').css({height: '100%'});
  $('html').css({height: '100%'});

  $('.cart-overlay').show();
});


$('.cart-overlay').click(function(e){
  e.preventDefault();
  $('.cart-drawer').removeClass('open_cartdrawer');
  $('body').removeClass('js-drawer-open');
  
  $('body').css({overflow: 'visible'});
  $('html').css({overflow: 'visible'});

  $('body').css({height: 'auto'});
  $('html').css({height: 'auto'});
  
  $(this).hide();
});

function carthtmldata(){
  $.ajax({
    type: 'GET', 
    url: '/cart',
    dataType: 'html',
    success: function(cart_html) {
      var cartdrawer_content = $(cart_html).find('.cart-value').html();
      $('.cart-value').html(cartdrawer_content);
      var cart_count = $(cart_html).find('#CartCount').html();
      $('#CartCount').html(cart_count);
      var cartCount = $(cart_html).find('.cart-value .drawer__title').attr('data-count');
      console.log(cartCount);
      if(cartCount == 0){
        $('#CartCount').addClass('hide');
      }else{
        $('#CartCount').removeClass('hide');
      }
      
      $('.cart-drawer').addClass('open_cartdrawer');
      $('body').addClass('js-drawer-open');
      $('.cart-overlay').show();
       $('.cart__loading').removeClass('ready');
    }
  });
}
function qunatityChange(cart_item, cart_varid){
  $.ajax({
    type: 'POST', 
    url: '/cart/change.js',
    dataType: 'json', 
    data : {
      "quantity": cart_item,
      "id": cart_varid,
    },
    success: function() {
      carthtmldata();
    }
  });

}

 $(document).on('click', '.upsell-btn', function(){
   $('.cart__loading').addClass('ready');
    var id = $(this).data('id');
    var data = {
      "quantity": 1,
      "id": id
    };
    $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data : data,
      success: function() {
        carthtmldata();
        
      }
  });
});

function drawerPlus(item) {
   $('.cart__loading').addClass('ready');
  var cart_item = parseInt($(item).prev().val());
  var cart_varid = $(item).prev().data('variantid');
  cart_item += 1;
  qunatityChange(cart_item, cart_varid);

}
function drawerMinus(item) {
   $('.cart__loading').addClass('ready');
  var cart_item = parseInt($(item).next().val());
  var cart_varid = $(item).next().data('variantid');
  cart_item -= 1;
  qunatityChange(cart_item, cart_varid);
}
function drawerInputitem(item) {
   $('.cart__loading').addClass('ready');
  var cart_item = parseInt($(item).val());
  var cart_varid = $(item).data('variantid');
  qunatityChange(cart_item, cart_varid);
}
function drawerRemove(item) {
   $('.cart__loading').addClass('ready');
  var cart_item = 0;
  var cart_varid = $(item).data('variantid');
  qunatityChange(cart_item, cart_varid);
}
function changeVariant(item) {
var id = $(item).val();
var price = $(item).find('option[value="'+id+'"]').attr('price');
var img = $(item).find('option[value="'+id+'"]').attr('img');
$(item).next('.upsell-btn').attr('data-id',id);
$(item).parents('.why-not-pro-list').find('.pro-list-price').html('<span>'+price+'</span>');
$(item).parents('.why-not-pro-list').find('.pro-list-img img').attr('src',img);
}



// Cart drawer fuctionality js ===========end//});